import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BarsicService } from 'src/app/services/barsic.service';
import { TestService } from 'src/app/services/test.service';
import { TimerService } from 'src/app/services/timer.service';
import Swal from 'sweetalert2';

declare var jQuery:any;

@Component({
  selector: 'app-barsic',
  templateUrl: './barsic.component.html',
  styles: [
  ]
})
export class BarsicComponent implements OnInit {
  @ViewChild('instructions') instructions: ElementRef;

  public questions;
  public index;
  public answers = [];
  public numbers=[];
  public counter = 0;
  public scholarship="default";
  public seconds=0;
  public minutes=0;
  public time;
  public onTest=false;
  public testData;
  public photoTaked = false;
  public trigger = false;
  public correctArray=[];

  public selectedQuestion={
    title: "",
    opcA: {
        text:"",
        value:0
    },
    opcB: {
        text:"",
        value:0
    },
    opcC: {
        text:"",
        value:0
    },
    opcD: {
        text:"",
        value:0
    },
    opcE: {
        text:"",
        value:0
    },
    numbers: [],
    correctNumbers:[],
    factor:"",
    correctNumberValue:0,
    type:""
  };

  public score = {
    "informacion":0,
    "razonamientoVerbal":0,
    "comprensionDeVocabulario":0,
    "razonamientoLogico":0,
    "razonamientoNumerico":0,
   }

   public texts;
   
  constructor(private barsicService:BarsicService, private timer:TimerService, private testService:TestService, private router:Router) {
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
      },
      err=>console.log(err)
    )
    this.numbers[0]=0;
    this.numbers[1]=0;
    this.barsicService.getQuestions().subscribe(
      resp=>{
 
        this. questions = resp;
      },
      err=>{
        console.log(err);
      }
    )
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;

  }

  ngOnInit(): void {

  }

  reload(){
    location.reload()
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.barsicInstructions;
        }, 500)
      },
      err=>console.log(err)
    )    

  }

  startTest(){
    this.testService.testStarted = true;

    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    
    this.timer.start();
    this.onTest=true;
    this. time = setInterval(()=>{
      this.seconds = this.timer.seconds;
      this.minutes = this.timer.minutes;
      if(this.minutes==10){
        this.endTest();
      }

    },1000);

    this.selectedQuestion = this.questions[0];
    this.index = 0;
    this.score = {
    "informacion":0,
    "razonamientoVerbal":0,
    "comprensionDeVocabulario":0,
    "razonamientoLogico":0,
    "razonamientoNumerico":0,
    };

    this.answers = [];
    
  }

  setScholarship(e){
    this.scholarship = e.target.value;
  }

  selectText(opc){
    this.answers.push(opc);
    if (opc==='A'){
      for (let f in this.score){
        if (this.selectedQuestion.factor==String(f)){
          if(this.selectedQuestion.opcA.value>0){
            this.counter=this.counter+1;
            this.correctArray.push(1);
          }else this.correctArray.push(0);
          this.score[f] = this.score[f]+this.selectedQuestion.opcA.value;
        }
      }
    }

    if (opc==='B'){
      for (let f in this.score){
        if (this.selectedQuestion.factor==String(f)){
          if(this.selectedQuestion.opcB.value>0){
            this.counter=this.counter+1;
            this.correctArray.push(1);
          }else this.correctArray.push(0);
          this.score[f] = this.score[f]+this.selectedQuestion.opcB.value;
        }
      }
    }

    if (opc==='C'){
      for (let f in this.score){
        if (this.selectedQuestion.factor==String(f)){
          if(this.selectedQuestion.opcC.value>0){
            this.counter=this.counter+1;
            this.correctArray.push(1);
          }else this.correctArray.push(0);
          this.score[f] = this.score[f]+this.selectedQuestion.opcC.value;
        }
      }
    }
    if (opc==='D'){
      for (let f in this.score){
        if (this.selectedQuestion.factor==String(f)){
          if(this.selectedQuestion.opcD.value>0){
            this.counter=this.counter+1;
            this.correctArray.push(1);
          }else this.correctArray.push(0);
          this.score[f] = this.score[f]+this.selectedQuestion.opcD.value;
        }
      }
    }
    if (opc==='E'){
      for (let f in this.score){
        if (this.selectedQuestion.factor==String(f)){
          if(this.selectedQuestion.opcE.value>0){
            this.counter=this.counter+1;
            this.correctArray.push(1);
          }else this.correctArray.push(0);
          this.score[f] = this.score[f]+this.selectedQuestion.opcE.value;
        }
      }
    }
    this.nextQuestion();
    
  }

  selectNumber(){
    if(this.numbers[0]&&this.numbers[1]){
      this.answers.push(this.numbers);
      if (this.numbers[0]==this.selectedQuestion.correctNumbers[0]&&this.numbers[1]==this.selectedQuestion.correctNumbers[1]){
        this.score['razonamientoNumerico'] = this.score['razonamientoNumerico'] + this.selectedQuestion.correctNumberValue;
        this.counter=this.counter+1;
        this.correctArray.push(1);
  
      }else{
        this.correctArray.push(0);
  
      }
      this.nextQuestion();
    }else{
      Swal.fire("Debe completar todos los campos");
    }
  }

  close(){
    clearInterval(this.time);
    this.timer.stop();
  }

  nextQuestion(){
    this.index = this.index + 1;
    this.selectedQuestion = this.questions[this.index];
    this.numbers=[];

    //console.log(this.index);
    //console.log(this.selectedQuestion);
    if(!this.selectedQuestion||this.minutes>=10){
      this.trigger = !this.trigger;
      this.onTest=false;
      clearInterval(this.time);
      this.timer.stop();
      if(this.time>=10){
        Swal.fire('Tiempo terminado. Test finalizado',"", 'success');
      }else{

        Swal.fire('Test finalizado',"", 'success');
      }
      jQuery("#myModal").modal("hide");
      
      this.barsicService.createReport(this.score, this.answers, this.scholarship, this.counter, this.correctArray).subscribe(
        res=>{

          var testData = this.testService.selectedTestData;
          testData.isCompleted = true;
          testData.reportId = res._id;
          testData.completeDate = Date.now();

          this.testService.updateTest(testData).subscribe(
            r=>{
       
              this.router.navigateByUrl('dashboard/requestedTests');
            },
            e=>console.log(e)
          );
        },
        err=> console.log(err)
      )
    }
  }

  endTest(){
    
    this.onTest=false;
      console.log(this.score);
      console.log(this.answers);
      clearInterval(this.time);
      this.timer.stop();
      if(this.time>=10){
        Swal.fire('Tiempo terminado. Agradecemos tu participación',"", 'success');
      }else{

        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
      }
      jQuery("#myModal").modal("hide");
      
      this.barsicService.createReport(this.score, this.answers, this.scholarship, this.counter, this.correctArray).subscribe(
        res=>{
          
          var testData = this.testService.selectedTestData;
          testData.isCompleted = true;
          testData.reportId = res._id;
          testData.completeDate = Date.now();

          this.testService.updateTest(testData).subscribe(
            r=>{
          
              this.router.navigateByUrl('dashboard/requestedTests');
            },
            e=>console.log(e)
          );
        },
        err=> console.log(err)
      )

  }

}